import React, { useMemo } from "react";

import type {
  ProgressBarDeviceConfig,
  ProgressBarViewProps,
} from "@intelligems/ig-types";

import { ProgressBarContext } from "../../ProgressBarView/context/ProgressBarContext";
import { useProgressBarState } from "../../ProgressBarView/context/useProgressBarState";
import { ProgressBarContextType } from "../../ProgressBarView/types";

export interface ProgressBarContextProviderProps extends ProgressBarViewProps {
  device: ProgressBarDeviceConfig;
  hasMediaQuery?: boolean;
  children: React.ReactNode;
}

export const ProgressBarContextProvider = (
  props: ProgressBarContextProviderProps
) => {
  const { children, formatter, config, device, cartValue, hasMediaQuery } =
    props;
  const state = useProgressBarState(props);
  const value = useMemo<ProgressBarContextType>(
    () => ({
      config,
      device,
      formatter,
      cartValue,
      state,
      hasMediaQuery,
    }),
    [config, device, formatter, cartValue, state, hasMediaQuery]
  );

  return (
    <ProgressBarContext.Provider value={value}>
      {children}
    </ProgressBarContext.Provider>
  );
};
